import "../../css/master.css";
import "../../css/app.css";
import "../../css/custom.css";
import { useAtom, atom } from 'jotai';
import Loader from '../../loader/loader';
import MainComponent from "./main_component";
import SideBar from "../../sidebar/sidebar"
import { useLocation } from 'react-router-dom';
import CheckUserInfoAgreement from "../../checkUserInfoAgreement";

const isLoadingAtom = atom(false);

function ContactConfirm({ AuthVerify }) {

    const [isLoading, setIsLoading] = useAtom(isLoadingAtom);
    const location = useLocation();

    if (!location.state) {
        window.location.replace("/contact_create");
    }

    const handleLoading = (set) => {

        setIsLoading(set)
    }

    return (
        <>
            <div>
                {isLoading === true ? <Loader /> : null}
                <div className="header-utility">
                    <div className="header-utility-inner">
                        <ul className="header-utility-list sub">
                        </ul>
                    </div>
                </div>
                <div className="mod-hdg-l1">
                    <div className="inner">
                        <h1 className="hdg">ファーストコンタクトセンター</h1><span className="sub of-bottom">お問い合わせ・ご相談</span>
                    </div>
                </div>
                <main className="site-main">
                    <section className="sct-primary">
                        <div className="ls-row str-column" id="ls-row-3-col-1-row-2">
                            <div className="ls-col str-column-side" id="ls-row-3-col-1-row-2-col-1">
                                <nav className="nav-local" data-current-layer="2">
                                    <h2 className="str-hidden">ローカルナビゲーション</h2>
                                    <div className="">
                                        <div style={{ padding: "10px 30px 10px 16px" }}>
                                            <span id="topUserName">NECファーストコンタクトセンター</span>
                                        </div>
                                    </div>
                                    <div className="ls-row content" id="ls-row-3-col-1-row-2-col-1-row-1-col-2-row-1" aria-hidden="false">
                                        <ul className="list">
                                            <li><span><a>STEP1 ご相談内容の入力</a></span>
                                            </li>
                                            <li className="is-current"><span><a>STEP2 入力内容の確認</a></span>
                                            </li>
                                            <li><span><a>STEP3 送信完了</a></span>
                                            </li>
                                        </ul>
                                    </div>
                                </nav>
                            </div>
                            <MainComponent handleLoading={handleLoading} />
                        </div>
                    </section>
                </main>
            </div>
        </>
    );
}


export default ContactConfirm;